<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="title">
    <h5 class="d-inline-block">
        {{ currentEngineRadio.name + (pairToEngineRadio ? ' to ' + pairToEngineRadio.name : '') }}
    </h5>
    <button (click)="resetToOriginalValues()" *ngIf="needResetButton" windeTransparent>
        <sui-svg-icon icon="refresh" windeGrey />
        <span>Reset default</span>
    </button>
</div>

<winde-tabs-nav
    (tabChanged)="changeTab($event)"
    (tabClosed)="closeBandwidthTab($event)"
    *ngIf="bandwidthList && bandwidthList.length > 0"
    [activeTab]="selectedTabIndex"
    [customClass]="'tabs-nav--doc-tabs mt-2'"
    [showClose]="true"
    [tabsList]="bandwidthList"
    [translationPrefix]="'project.frequencyTabs.tab'"
>
</winde-tabs-nav>

<div *ngIf="originEngineRadio && currentEngineRadio?.pdbConfig?.channelConfigs?.[selectedTabIndex]" class="card mb-2">
    <div *ngIf="hasAuthority$ | async as hasAuthority" class="card-body">
        <div class="form-group mb-2">
            <winde-custom-list-box
                (selectedListChange)="setUpdatedChannelsList($event)"
                [(selectedList)]="selectedFrequencies"
                [availableList]="availableFrequencies"
                [isReadonlyMode]="!hasAuthority"
                [isRequired]="true"
                [showValidationText]="true"
            >
            </winde-custom-list-box>
        </div>
    </div>
    <div *ngIf="pairToEngineRadio" class="card-body">
        <h5>{{ pairToEngineRadio ? pairToEngineRadio.name + ' frequencies: ' : '' }}</h5>
        <div class="frequency-list">
            <p *ngFor="let frequency of pairToEngineRadio.pdbConfig.channelConfigs[selectedTabIndex].frequencies">
                {{ frequency + ', ' }}
            </p>
        </div>

        <div class="frequency-list">
            <p *ngIf="!pairToEngineRadio.pdbConfig.channelConfigs[selectedTabIndex].frequencies.length">
                <small class="frequency-list_error">{{ 'The Related Engine Radio should have at least one frequency' }}</small>
            </p>
        </div>
    </div>
</div>
